export default __webpack_public_path__ + "static/media/portfolio-page-2021.559727fd.png";